module.exports = __webpack_public_path__ + "8f479d2ef3689f5c05576cad3d8188c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/amazon_com_2023_chart.png
// module id = 1631
// module chunks = 0